import React from "react"
import { globals } from "../Globals/Globals"


const MediaPlayer = (props) => {
    function endsWith(p_str, p_suffix) {
        let str = p_str.trim().toLowerCase()
        let suffix = p_suffix.trim().toLowerCase()
        let result = str.indexOf(suffix, str.length - suffix.length) !== -1;

        if (globals.parameters.debugging)
            console.log(`endsWith(${p_str},${p_suffix}) -> ${result}`)
        return result
    }

    const mp4_rendering = (ps_mp4_url_filename) => {
        console.log("mp4_rendering")
        return(<video id="home-video" 
            crossorigin="anonymous" playsinline="" preload="auto" muted="true" loop="true" tabindex="-1"
            autoplay={props.autoplay?"true":"false"} 
            //autoplay="true" 
            src={ps_mp4_url_filename}
            />)
    }

    const youtube_rendering = () => {
        console.log("youtube_rendering")
        return(<iframe 
                className='video'
                title='Youtube player'
                width="100%"
                height="100%"
                sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                allowfullscreen="true"
                src={`https://youtube.com/embed/${props.youtubeID_or_MP4url}?autoplay=${props.autoplay?1:0}`}>
        </iframe>)
    }
        
    const videoRendering = () => {
        if (globals.parameters.debugging)
            console.log("MediaPlayer::props.youtubeID_or_MP4url ->",props.youtubeID_or_MP4url)
        if (props.youtubeID_or_MP4url && props.youtubeID_or_MP4url.length){        
            //Return stored video flow
            return (endsWith(props.youtubeID_or_MP4url,".mp4")?mp4_rendering(props.youtubeID_or_MP4url):youtube_rendering(props.youtubeID_or_MP4url))
        }
        else {
            //Return static picture
            return(
                <>
                <img
                    //id = "home-video"
                    width="100%"
                    height="100%"
                    src_old="https://i.vimeocdn.com/video/1449210825-79d671233bc3780a6c12c0ec819f752bbb44b392a88dd4ff734bf58794cec5ce-d?mw=3400&mh=1913&q=70"
                    src={`${globals.dico.video_fallback_picture}`}
                /></>)
        }
    }

    return(<>{videoRendering()}</>)     
}

export default MediaPlayer;